var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-card-tweened"},[_c('app-heading',{staticClass:"title-number-card-tweened",attrs:{"level":"h3"}},[_vm._v(_vm._s(_vm.formatNumber))]),_c('app-heading',{staticClass:"subtitle-card-tweened",attrs:{"level":"h6"}},[_vm._v(_vm._s(_vm.formatLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }